import type { ReactNode } from "react";
import s from "./Settings.module.css";

export function Row({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  return (
    <div className={s.row}>
      <div className={s.rowText}>
        <div className={s.rowLabel}>{label}</div>
        {hint && <div className={s.rowHint}>{hint}</div>}
      </div>
      <div className={s.rowControl}>{children}</div>
    </div>
  );
}

export function Notice({ kind, children }: { kind: "ok" | "warn" | "err"; children: ReactNode }) {
  return (
    <p className={`${s.notice} ${s[kind]}`} role={kind === "err" ? "alert" : "status"}>
      {children}
    </p>
  );
}
